import * as React from 'react';
import { MessageDescriptor } from 'react-intl';
import { intl } from 'i18n';
import displatMessages from '../displayMessages';


interface Props {
    isChecked: boolean;
    leftMessage?: MessageDescriptor;
    rightMessage?: MessageDescriptor;
    onToggle?: (newValue: boolean) => void;
    extraClass?: string;
}

export const ToggleTextSwitch: React.FunctionComponent<Props> = (props) => {
    return (
        <div className={`lx-toggle-text-switch-container ${props.extraClass ?? ''}`}>
            <button
                className={`unstyled ${props.isChecked ? 'active' : ''}`}
                onClick={() => {if(props.onToggle) {props.onToggle(!props.isChecked);}} }>
                {intl.formatMessage(props.leftMessage ?? displatMessages.uiDefaultAnswerCorrectToggle)}
            </button>
            <button
                className={`unstyled ${props.isChecked ? '' : 'active'}`}
                onClick={() => {if(props.onToggle) {props.onToggle(!props.isChecked);}}}>
                {intl.formatMessage(props.rightMessage ?? displatMessages.uiDefaultAnswerWrongToggle)}
            </button>
        </div>
    );
};
